import React from "react";
import MovementPurposeManagement from "../movementPurpose/MovementPurposeManagement";

export default function ToAndFroMastersSection({ onPurposeMastersChange, onNotify }) {
  return (
    <div
      id="tf-masters"
      className="user-builder-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Master table management</h3>
        <p className="user-builder-panel__hint">
          Configure movement purposes used across the directory and forms.
        </p>
      </div>
      <div style={{ marginTop: "1rem" }}>
        <MovementPurposeManagement
          onNotify={onNotify}
          onClose={() => {}}
          onPurposeUpdate={onPurposeMastersChange}
        />
      </div>
    </div>
  );
}
